import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "satellite-off",
  "use": "satellite-off-usage",
  "viewBox": "0 0 93.1 93",
  "content": "<symbol viewBox=\"0 0 93.1 93\" id=\"satellite-off\"><g id=\"satellite-off_图层_2\" data-name=\"图层 2\"><g id=\"satellite-off_图层_1-2\" data-name=\"图层 1\"><path d=\"M92.67,73.43l-9.89-27.7a9.07,9.07,0,0,0-8.62-6.24H68.43A5.27,5.27,0,0,0,64,41.89,84.93,84.93,0,0,1,51.07,57.25l-.73.68a5.52,5.52,0,0,1-3.78,1.48h0a5.53,5.53,0,0,1-3.8-1.48l-.85-.8A83.23,83.23,0,0,1,29,41.89a5.26,5.26,0,0,0-4.41-2.4H18.44a9,9,0,0,0-8.68,6.27L.4,72.87a8.8,8.8,0,0,0,2,8.72,9.08,9.08,0,0,0,8.87,2.61l18.83-4.61a3.2,3.2,0,0,1,2.67.53L47.74,91.2A9.13,9.13,0,0,0,53.2,93a9.29,9.29,0,0,0,2.3-.29l30.78-7.87a9.13,9.13,0,0,0,5.67-4.33A8.9,8.9,0,0,0,92.67,73.43ZM53.79,86.93l.88-.2L54,86.9Z\" /><path d=\"M46.59,0A23.47,23.47,0,0,0,23.14,23.44c0,10.74,11.76,23.29,18.07,30L42.67,55a5.32,5.32,0,0,0,7.83,0l.39-.43c5.92-6.43,18.25-19.81,18.25-31.17C69.15,10.3,59.24,0,46.59,0Zm-.44,34A11.55,11.55,0,1,1,57.7,22.48,11.56,11.56,0,0,1,46.15,34Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/satellite-off.svg
// module id = mdtO
// module chunks = 264